import { render, staticRenderFns } from "./city-info.mpx?vue&type=template&id=cc6c6568&scoped=true&component=true&componentId=city-infod53d1460"
import script from "./city-info.mpx?vue&type=script&lang=js&component=true&componentId=city-infod53d1460"
export * from "./city-info.mpx?vue&type=script&lang=js&component=true&componentId=city-infod53d1460"
import style0 from "./city-info.mpx?vue&type=style&index=0&id=cc6c6568&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22md53d1460%22%7D&component=true&componentId=city-infod53d1460"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6c6568",
  null
  
)

export default component.exports